import { Component } from "react";

const title = "Join The Herox";
const desc = "Join a genuine community of 150,000 Herox!";
const btnText = "Join Our Discord";


class Community extends Component {
    render() { 
        return (
            <section className="community padding-top padding-bottom" style={{backgroundImage: "url(/assets/images/community/bg.jpg)"}}>
                <div className="container">
                    <div className="comminity__wrapper">
                        <div className="community__content text-center" data-aos="zoom-in" data-aos-duration="1000">
                            <h2>{title}</h2>
                            <p>{desc}</p>
                            <a href="#" className="default-btn"><span>{btnText}</span></a>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default Community;